var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffe67b;}.b{fill:#fcc454;}.c{fill:#f7a521;}.d{fill:none;stroke:#d9efff;stroke-linecap:round;stroke-linejoin:round;stroke-width:0;}.e{fill:#ff8c7d;}.f,.g{fill:#7c20bf;}.g{opacity:0.65;}.h{fill:#5f4870;opacity:0;}.i{fill:#ed5454;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M134,206.661v57.07a13.165,13.165,0,0,1-13.158,13.141H13.158A13.165,13.165,0,0,1,0,263.731v-57.07a13.033,13.033,0,0,1,1.578-6.232,13.168,13.168,0,0,1,11.581-6.909H120.838a13.17,13.17,0,0,1,11.489,6.744A13.017,13.017,0,0,1,134,206.661Z",
    transform: "translate(0 -142.872)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M323.295,206.661v57.07a13.165,13.165,0,0,1-13.158,13.141H256.4V193.52h53.732a13.17,13.17,0,0,1,11.489,6.744A13.02,13.02,0,0,1,323.295,206.661Z",
    transform: "translate(-189.298 -142.872)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M134,305.621v16.412a13.165,13.165,0,0,1-13.158,13.141H13.158A13.165,13.165,0,0,1,0,322.033V306.359l33.815-33.83,33.291-.021,32.856-.018Z",
    transform: "translate(0 -201.174)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M323.295,305.621v16.412a13.165,13.165,0,0,1-13.158,13.141H256.4V272.508l32.856-.018Z",
    transform: "translate(-189.298 -201.174)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.578 50.648)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 0.001,
    transform: "translate(65.527 44.944)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 0.003,
    transform: "translate(65.527 44.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M136.78,200.264l-61.14,37a7.815,7.815,0,0,1-4.08,1.2h0a8.558,8.558,0,0,1-4.282-1.191L6.03,200.429a13.167,13.167,0,0,1,11.581-6.909H125.29A13.171,13.171,0,0,1,136.78,200.264Z",
    transform: "translate(-6.03 -193.52)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.009 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M226.971,22.633a3.933,3.933,0,0,1-5.477-.947l-3.949-5.59V38.52a3.931,3.931,0,0,1-7.862,0V16.1l-3.947,5.59a3.929,3.929,0,0,1-6.426-4.523L210.167,1.785A4.22,4.22,0,0,1,213.5,0h.026a.089.089,0,0,1,.026,0h.115a.089.089,0,0,1,.026,0h.024a4.221,4.221,0,0,1,3.339,1.782l10.858,15.379A3.92,3.92,0,0,1,226.971,22.633Z",
    transform: "translate(-146.625 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M15.42,48.283l6.76,1.164a3.926,3.926,0,1,0,1.335-7.738L4.968,38.517A4.214,4.214,0,0,0,.1,43.38L3.287,61.935a3.931,3.931,0,0,0,7.748-1.329L9.873,53.848,25.718,69.7a3.928,3.928,0,0,0,5.564-5.547Z",
    transform: "translate(-0.035 -28.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M419.378,39.589a4.227,4.227,0,0,0-3.7-1.17l-18.547,3.192a3.926,3.926,0,1,0,1.335,7.737l6.76-1.164-15.862,15.87a3.928,3.928,0,0,0,5.564,5.547l15.844-15.852-1.162,6.758a3.926,3.926,0,0,0,3.209,4.534,3.978,3.978,0,0,0,.67.057,3.93,3.93,0,0,0,3.87-3.262l3.192-18.559A4.215,4.215,0,0,0,419.378,39.589Z",
    transform: "translate(-286.624 -28.319)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M255.993,42.446V0h.058a.089.089,0,0,1,.026,0h.024a4.221,4.221,0,0,1,3.339,1.782L270.3,17.164a3.928,3.928,0,0,1-6.423,4.523l-3.949-5.59V38.52A3.93,3.93,0,0,1,255.993,42.446Z",
    transform: "translate(-188.995)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M321.623,200.264l-61.14,37a7.815,7.815,0,0,1-4.08,1.2h0V193.52h53.734A13.171,13.171,0,0,1,321.623,200.264Z",
    transform: "translate(-189.295 -142.872)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailing);
export default __webpack_public_path__ + "static/media/mailing.cc7279e162c55ec7df4a4c40f369cb09.svg";
export { ForwardRef as ReactComponent };